import * as React from "react";
import { bannerMassImg, FOOTER_CONTENT, SEO } from "@/constants/wxHomepage";
import { VerticalCard } from "../../components/vertical-card";
import { HorizontalCards } from "../../components/horizontal-cards";
import { WxBanner } from "../../components/wx-banner";
import { WxOurInfomation } from "../../components/our-infomation";
import { Footer } from "@/components";
import { genBlock } from "@/utils/bem";
import { isWap } from "@/utils/tools";
import "./index.less";

const MASS_TYPE = [
  {
    imgUrl: require('@/assets/images/wx/img/custom-mass.png'),
    align: "center" as "center",
    title: "客服群发",
    descList: [
      "可触达48小时内有过互动的粉丝",
      "可发送多条消息",
      "支持图文消息、文字、链接组",
      "支持定时、循环发送",
      "突破公众号发文次数限制",
      "支持插入粉丝昵称、表情、链接文字、跳转文字",
    ],
  },
  {
    imgUrl: require('@/assets/images/wx/img/temp-mass.png'),
    align: "center" as "center",
    title: "模板群发",
    descList: [
      "不限发送次数，可触达所有粉丝",
      "可多条件筛选用户发送消息",
      "可使用定时群发功能",
      "适用于推送紧急/重要事件",
      "活动提醒等通知",
      "模板内容可插入粉丝昵称改变字体颜色",
    ],
  },
  {
    imgUrl: require('@/assets/images/wx/img/weixin-mass.png'),
    align: "center" as "center",
    title: "微信群发",
    descList: [
      "不受48小时互动限制",
      "支持插入表情、跳转文字",
      "已认证服务号每月可群发四次",
      "已认证订阅号每日可群发一次",
    ],
  },
];

const FUNC_INTRO_DATA = [
  {
    img: require("@/assets/images/wx/img/20@3x.png"),
    title: "支持多种类型跳转",
    desc: (
      <span>
        公众号关联小程序后，模板消息、
        <br />
        客服消息都可跳转小程序
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/21@3x.png"),
    title: "多维度筛选群发对象",
    desc: (
      <span>
        可按标签/标签筛选粉丝进行精准推送；
        <br />
        支持反向筛选，可选择临近失活用户
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/22@3x.png"),
    title: "定时推送消息",
    desc: (
      <span>
        设置消息推送时间，未开始前
        <br />
        可随时取消发送；
        <br />
        可选择免打扰时段
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/23@3x.png"),
    title: "循环发送",
    desc: <span>一次设置每日固定时间自动群发</span>,
  },
];

const SCENE_DATA = [
  {
    imgUrl: require("@/assets/images/wx/icon/waimai.png"),
    align: "left" as "left",
    title: "外卖场景",
    descList: [
      "客服消息支持发送文本",
      "图片、图文素材",
      "适用于推送外卖营销活动",
    ],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/huodong.png"),
    align: "left" as "left",
    title: "活动提醒",
    descList: [
      "重要活动开始时，利用模板消息",
      "告知粉丝活动的主题、时间以及",
      "活动链接，更好地引导用户",
      "参与活动",
    ],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/cuxiao.png"),
    align: "left" as "left",
    title: "促销提醒",
    descList: [
      "促销活动开始时，根据不同的",
      "粉丝标签推送不同文案的模板消息",
      "更好地提升促销活动的转化率",
    ],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/tongzhi.png"),
    align: "left" as "left",
    title: "重要通知",
    descList: [
      "有重要通知时，可以通过模板",
      "消息随时推送给全部粉丝；",
      "不受每月推送额度的限制",
    ],
  },
];

const block = genBlock("kz-weixin-mass");

const WxMass: React.FC<{}> = () => {

  React.useEffect(() => {
    document.querySelector('meta[name="keywords"]').setAttribute('content', SEO.mass.keyword);
    document.querySelector('meta[name="description"]').setAttribute('content', SEO.mass.description);
  }, [])

  return (
    <div className={block()}>
      <WxBanner
        img={bannerMassImg}
        btnText={"立即使用"}
        btnClick={isWap() ? null : "/v3/weixin/list"}
      />
      <div className={block("mass-type")}>
        <div className={block("type-title")}>三种群发类型</div>
        <div className={block("type-wrap")}>
          {MASS_TYPE.map((item, index) => (
            <VerticalCard {...item} isDescIcon key={index} />
          ))}
        </div>
      </div>
      <HorizontalCards
        title="功能特性"
        cards={FUNC_INTRO_DATA}
        style={{ backgroundColor: "#F4F8FF" }}
      />
      <div className={block("scene")}>
        <div className={block("scene-title")}>适用场景</div>
        <div className={block("scene-wrap")}>
          {SCENE_DATA.map((item) => (
            <VerticalCard
              {...item}
              style={{ padding: "10px 20px 10px 30px" }}
            />
          ))}
        </div>
      </div>
      <WxOurInfomation />
      <Footer {...FOOTER_CONTENT} />
    </div>
  );
};

export default WxMass;
